<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">RESET 2FA</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="panel panel-filled">
        <div class="panel-body">
          <form @submit.prevent="submit" class="form-horizontal">
            <div class="form-group">
              <label for="email" class="col-xs-4 control-label">Email</label>
              <div class="col-xs-8">
                <input
                  id="email"
                  type="text"
                  v-model="email"
                  class="form-control"
                  placeholder=""
                />
              </div>
            </div>

            <button
              v-if="loading"
              class="btn btn-default btn-block"
              disabled=" "
            >
              <i class="fad fa-spinner-third fa-spin m-r-xs"></i>Loading
            </button>
            <button
              v-else-if="!email"
              class="btn btn-default btn-block"
              disabled=" "
            >
              Submit
            </button>
            <button v-else class="btn btn-accent btn-block text-accent">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nativeToast from "native-toast";
import admin from "@/api/admin";

export default {
  data() {
    return {
      email: this.$route.params.email || null,
      loading: false
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      await admin
        .reset2fa({
          email: this.email
        })
        .then(() => {
          this.loading = false;
          this.email = null;
          nativeToast({
            message: "Successfully.",
            position: "top",
            timeout: 3000,
            type: "success"
          });
        })
        .catch(error => {
          this.loading = false;
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error"
          });
        });
    }
  }
};
</script>
